import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>Check out my Skills!</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/img-9.jpg'
              text='HTML, CSS, JavaScript, JavaScript Frameworks,
               Cross-Browser Compatibility, Web Performance Optimization'
              label='Front End'
              path='/'
            />
            <CardItem
              src='images/img-2.png'
              text='Robot Framweork skills, where Im using Robot Framweork for Test Automation Tasks'
              label='Robot Framework'
              path='/'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/img-3.jpeg'
              text='Manual & Automation Testing: Selenium ,Selenium IDE, Cypress, Insomnia'
              label='QA Automation'
              path='/'
            />
            <CardItem
              src='images/img-4.jpg'
              text='Using React Native & React JS for Mobile and Web based Applications'
              label='React'
              path='/'
            />
            <CardItem
              src='images/img-8.jpg'
              text='Have knowledge in various OOP like: C, C++, Java, Python'
              label='Object Oriented Programming'
              path='/'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/img-10.png'
              text='Angular experience on MultiPage and SinglePage Applications'
              label='Angular'
              path='/'
            />
            <CardItem
              src='images/img-11.png'
              text='Developing Mobile Apps for Ios and Android'
              label='Ionic'
              path='/'
            />
            <CardItem
              src='images/img-12.png'
              text='Designing and planning projects using Figma'
              label='Figma'
              path='/'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
